<template>
  <div id="mineH5">
	<plugin />
    <Tabbar msg="/mineH5" />
			<div class="app-top-border"></div>
			   <!-- <div class="user" >
			        <div class="avatar" >
			            <img :src="userInfo.headimgurl" />
			        </div>
			        <div class="username">
			            {{userInfo.nickName}}
			        </div>
			       
			        <div  class="msg" bindtap='toNotification'>
			            <img src="/assets/icon-msg.png" mode="aspectFit"/>
			            <div class="number" v-if='send_num>0'>{{send_num}}</div>
			        </div>
			    </div> -->
				<div class='userNo'></div>
			
			    <div class='accountBtn'>
			          <img src="https://test.xiaojudai.cn/uploads/admin/Banner/images/20190828/ac39d8c361ee5ef78319447691cf55db.png"  class='homeimg'></img>
			          <div class='accountBtnBox'>
			                <div class="app-btn" @click='toQuest'  style='width:2.78rem;height:0.74rem;margin-bottom:40rpx;line-height:0.74rem;'>定制橘袋</div>
			          </div> 
			    </div>
			
			    <div class="shortcut">
			        <div  class="item" @click="toOrder">
			            
			            <div class="icon">
			      
			                <img src="../assets/home-shortcut-order.png" mode="aspectFit"/>
			            </div>
			            <div class="name">我的订单</div>
			        </div>
			        <div  class="item"  @click="toAddress">
			            <div class="icon">
			                <img src="../assets/home-shortcut-address.png" mode="aspectFit"/>
			            </div>
			            <div class="name">我的地址</div>
			        </div>
			        <div class="item" @click='toVip'>
			            <div class="icon">
			                <img src="../assets/home-shortcut-vip.png" />
			            </div>
			            <div class="name">橘卡VIP</div>
			        </div>
			       
			        <div  class="item" @click='toreport'>
			            <div class="icon">
			                <img src="../assets/home-shortcut-coupon.png" />
			            </div>
			            <div class="name">我的报告</div>
			        </div>
			    </div>


			    <div class="menu">
			        <button  class="item" @click="toQ">
			            <span>常见问题</span>
			            <img src="../assets/icon-next4.png" />
			        </button>
			        <button class="item" @click="toAbout">
			            <span>关于我们</span>
			            <img src="../assets/icon-next4.png" />
			        </button>
			    </div>
				
				
				<div v-if='toastShow' class='toast'>{{toastMsg}}</div>
  </div>
</template>

<script>

import Tabbar from '@/components/tabbar.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'mineH5',
  components: {
      Tabbar,
		plugin
  },
  data() {
      return {
		  toastShow:false,
		  toastMsg:"",
      }
    },
    computed: {
     
    },
    mounted() {
     
     
    },
    methods:{

		toAbout(){
		  //  this.$router.push({
				// path:"about"
		  //  })
		  // window.open("https://www.nutri-packs.cn/gywm");
		  window.location.href="https://www.nutri-packs.cn/gywm"; 
		},
		toOrder(){
		   this.$router.push({
				path:"orderList"
		   })
		},
		toQuest(){
			this.$router.push({
				path:"beforeQuestion"
			})
		},
		toQ(){
			this.$router.push({
				path:"commonProblem"
			})
		},
		toreport(){
			this.$router.push({
				path:"report"
			})
		},
		toAddress(){
			this.$router.push({
				path:"homeAddress"
			})
		},
		toVip(){
			this.showToast("即将开通vip功能")
		},
		// 小提示
		showToast(Msg){
			let that = this
			this.toastMsg = Msg
			this.toastShow = true
			setTimeout(()=>{
				that.toastShow = false
				that.toastMsg = ""
			},1500)
		},
		// changeAddressFN(){
		// 	this.myAddressShow = false
		// }
		
			
    }
}
</script>
<style>
#mineH5{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  background-color: #fff;
  
  
}
#mineH5::-webkit-scrollbar {display:none}

.userNo{
	height: 1rem;
	background-color: #fff;
}
.user {
    display: flex;
    align-items: center;
    padding: 0.4rem;
    height: 1.48rem;
    width: 6.7rem;
    background-color: #fff;
    position: relative;
    /* top:0; */
    z-index: 2;
    overflow: hidden;
    border-top: 0.02rem solid #F4F2F0;
	box-sizing: content-box;
    
}
.user .avatar {
    width:1.14rem;
    height:1.14rem;
    flex-shrink: 0;
}
.user .avatar img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    background: #ccc;
}
.user .username {
    font-size:0.48rem;
    font-weight: 500;
    padding-left: 0.35rem;
    flex-shrink: 0;
}

.loginBtn{
    padding-left: 0.35rem;
    flex-shrink: 0;
    height: 0.58rem;
    font-size:0.4rem;
    font-family:SourceHanSansCN;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height: 0.58rem;
    letter-spacing: 0.01rem;
}

.user .msg {
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: 0.4rem;
    top: 0.6rem;
}
.user .msg img {
    width: 0.45rem;
/*    height: 100%; */
    float: right;
}
.user .msg .number {
    position: absolute;
    right: -0.08rem;
    top: 0.17rem;
    color: #fff;
    display: block;
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 0.3rem;
    background: #C25E4D;
    font-size: 0.2rem;
    line-height: 0.28rem;
    text-align: center;
}

.account {
    position: relative;
    z-index: 9;
    color: #fff;
    height: 3.44rem;
    padding:0 0.2rem;
    box-sizing: border-box; 
    width: 7.5rem;
	box-sizing: content-box;
    /* top:230rpx; */
}
.accountBtn{
   position: relative;
    z-index: 9;
    background-color: #fff;
    height: 3.44rem;
    padding:0 0.2rem;
    box-sizing: border-box; 
    width: 7.5rem;
    border: 0;
    border-radius: 0;
}
.accountBtn::after {
  border: none;
}
.account .account-bg {
    width: 100%;
    position: relative;
    z-index: 2;
     
    pointer-events: none;
}
.account .content {
    position: absolute;
    left: 0.8rem;
    top: 0.7rem;
    right: 0.8rem;
    z-index: 5;
    font-size: 0.3rem;
}
.account .content>view:first-child {
    font-size: 0.28rem;
}
.account .account-price {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 0.05rem;
}
.account .account-price .price span {
    font-size: 0.6rem;
    font-weight: bold;
}
.account .account-price navigator {
    margin-bottom: 0.15rem;
}
.account .report {
    position: absolute;
    width: 80%;
    left: 10%;
    bottom: -0.15rem;
    z-index: 1;
}
.account .report img {
    width: 100%;
}
.toLogs img{
  width: 0.13rem;
  height: 0.22rem;
  display: inline-block;
  margin-left: 0.2rem;
}
.shortcut {
    position:relative;
    /* top: 572rpx; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:2.55rem;
    width: 7.5rem;
    background-color: #fff;
    z-index: 8;
    padding: 0 0.6rem;
	
    box-sizing: border-box;

}
.shortcut .item {
    padding: 0 0.1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333333;
    font-size: 0.26rem;
    position: relative;
}

.orderNum{
    position: absolute;
    top:0;
    right:0;
    color: #fff;
    display: block;
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 0.3rem;
    background: #C25E4D;
    font-size: 0.2rem;
    line-height: 0.3rem;
    text-align: center;
}
.couponrNum{
    position: absolute;
    top:0;
    right:-0.08rem;
    color: #fff;
    display: block;
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 0.3rem;
    background: #C25E4D;
    font-size: 0.2rem;
    line-height: 0.3rem;
    text-align: center;
}
.shortcut .item .icon {
    display: flex;
    align-items: center;
	justify-content:center;
    width: 0.7rem;
    height: 0.7rem;
    /* overflow: hidden; */
    margin-bottom:0.15rem;
    position: relative;
}
.shortcut .item .icon  img {
    height: 0.52rem;
}

.share {
    margin: 0 0.4rem 0.8rem 0.4rem;
}
.share img {
    width: 100%;
}

.menu {
    margin:0 0.4rem;
    /* border-top: 1px solid #E5E5E5; */
}
.menu .item, .menu button.item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0.3rem 0.3rem 0;
    position: relative;
    color: #333;
    font-weight: 500;
    border: none;
    background: none;
    font-size: 0.28rem;
    line-height: normal;
    border-radius: 0;
    overflow: visible;
	width: 100%;
}
button{
	outline: none;
}

button::after{
  border: none;
  
}
.menu .item::after {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    right: 0;
    top: auto;
    background: #E5E5E5;
    height: 0.01rem;
    border: none;
}
.menu .item img {
    width: 0.14rem;
}
.official{
    z-index: 100;
    position: fixed;
    top: 0px;
    width: 7.5rem;
    left: 0;
    transition: all .6s;
}
.official2{
    top:-0.85rem
}
.activityBox{
  width: 7.5rem;
  height: 2rem;
  background-color: #fff;
  margin-bottom: 0.8rem;
}
.activityImg{
  width: 7.5rem;
  height: 2rem;
  display: block;
  position: relative;
}
.activityBtn{
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.25rem;
  display: flex;
  padding: 0.3rem;
}
.activityTxtImg{
  height: 0.25rem;
  width: 0.35rem;
  position: relative;
  top: 0.01rem;
}
.activityTxt{
  height: 0.25rem;
  line-height: 0.25rem;
  color: #fff;
}
.homeimg{
  width: 100%;
  max-height: 3.44rem;
}

.accountBtnBox{
  width: 2.78rem;
  position: absolute;
  top:1.35rem;
  left:0.77rem;
}

/* 海报 */
.sharePopBox{
  width: 7.5rem;
  height: 100vh;
  position: fixed;
  z-index: 99;
  left: 0;
  top:0;
  background-color: rgba(0, 0, 0, 0.5);
}
.sharePopImg{
  width: 7.5rem;
  height: 12rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.sharePopImg img{
  width: 100%;
  height: 100%;
}
.sharePopBtn{
  position: absolute;
  left: 0;
  width: 7.5rem;
  height:0.74rem;
  padding: 0 0.5rem;
  box-sizing: border-box;
  bottom: 1.4rem;
  display: flex;
  line-height: 0.74rem;
  font-size:0.28rem;
  font-family:PingFangSC-Medium;
  font-weight:500;
  text-align: center;
  justify-content: space-around;
}
.closeImgBtn{
  width:2.78rem;
  height:0.74rem;
  color:rgba(194,94,77,1);
  border-radius: 0.6rem;
  background:rgba(255,255,255,1);
}
.saveImgBtn{
  width:2.78rem;
  height:0.74rem;
  background:rgba(194,94,77,1);
  border-radius: 0.6rem;
  color:rgba(255,255,255,1);

 
}
.toast{
	position: fixed;
	z-index: 999;
	top:50%;
	left: 50%;
	transform: translate( -50%, -50%);
	line-height: 0.4rem;
	opacity: 0.85;
	border-radius: 0.1rem;
	background-color: rgba(85, 85, 85, 1);
	text-align: center;
	padding: 0.04rem 0.2rem;
	color: rgba(255, 255, 255, 1);
	font-size: 0.2rem;
	text-align: left;
	font-family: SourceHanSansSC-regular;
}
</style>